import Vue from "vue";
import VueRouter from "vue-router";
import { isApiBaseReady } from "@/utils/bootstrap";
import { isLoggedIn, isWhiteRoute } from "@/utils/permission";
Vue.use(VueRouter);

// 定义路由
const routes = [
  {
    path: "/splash",
    name: "splash",
    component: () => import("@/views/pages/splash/splash.vue"),
  },
  {
    path: "/",
    name: "Index",
    component: () => import("@/views/pages/index/index.vue"),
  },
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/login/login.vue"),
  },
  {
    path: "/register",
    name: "register",
    component: () => import("@/views/login/register.vue"),
  },
  {
    path: "/discount",
    name: "discount",
    component: () => import("@/views/discount/discount.vue"),
  },
  {
    path: "/customer",
    name: "customer",
    component: () => import("@/views/customer/customer.vue"),
  },
  {
    path: "/help",
    name: "help",
    component: () => import("@/views/help/index.vue"),
  },
  {
    path: "/notice",
    name: "notice",
    component: () => import("@/views/customer/old_customer.vue"),
  },
  {
    path: "/apply-record",
    name: "applyRecord",
    component: () => import("@/views/customer/applyRecord.vue"),
  },
  {
    path: "/detail",
    name: "detail",
    component: () => import("@/views/detail/detail.vue"),
  },
  {
    path: "/invite",
    name: "invite",
    component: () => import("@/views/invite/invite.vue"),
  },
  {
    path: "/vip",
    name: "vip",
    component: () => import("@/views/discount/vip/vip.vue"),
  },
  {
    path: "/vip-detail",
    name: "vipDetail",
    component: () => import("@/views/discount/vip/detail.vue"),
  },
  {
    path: "/invite-new",
    name: "inviteNew",
    component: () => import("@/views/invite/old_invite.vue"),
  },
  {
    path: "/invite-record",
    name: "inviteRecord",
    component: () => import("@/views/invite/record.vue"),
  },
  {
    path: "/setting",
    name: "setting",
    component: () => import("@/views/setting/index/index.vue"),
  },
  {
    path: "/settings",
    name: "settings",
    component: () => import("@/views/setting/settings/settings.vue"),
  },
  {
    path: "/password",
    name: "password",
    component: () => import("@/views/setting/password/password.vue"),
  },
  {
    path: "/pay-password",
    name: "payPassword",
    component: () => import("@/views/setting/payPassword/payPassword.vue"),
  },
  {
    path: "/edit",
    name: "edit",
    component: () => import("@/views/setting/edit/edit.vue"),
  },
  {
    path: "/record",
    name: "record",
    component: () => import("@/views/setting/record/record.vue"),
  },
  {
    path: "/welfare",
    name: "welfare",
    component: () => import("@/views/setting/welfare/welfare.vue"),
  },
  {
    path: "/withdrawal",
    name: "withdrawal",
    component: () => import("@/views/setting/withdrawal/withdrawal.vue"),
  },
  {
    path: "/withdrawalTop",
    name: "withdrawalTop",
    component: () => import("@/views/setting/withdrawalTop/withdrawalTop.vue"),
  },
  {
    path: "/withdrawAdd",
    name: "withdrawAdd",
    component: () => import("@/views/setting/withdrawAdd/withdrawAdd.vue"),
  },
  {
    path: "/info",
    name: "info",
    component: () => import("@/views/setting/info/info.vue"),
  },
  {
    path: "/personal",
    name: "personal",
    component: () => import("@/views/setting/personal/personal.vue"),
  },
  {
    path: "/search",
    name: "search",
    component: () => import("@/views/pages/search/search.vue"),
  },
  {
    path: "/game-list",
    name: "gameList",
    component: () => import("@/views/pages/gameList/gameList.vue"),
  },
  {
    path: "/webview",
    name: "webview",
    component: () => import("@/views/pages/webview/webview.vue"),
  },
  {
    path: "/balance",
    name: "balance",
    component: () => import("@/views/setting/balance/balance.vue"),
  },
  {
    path: "/transfer",
    name: "transfer",
    component: () => import("@/views/setting/transfer/transfer.vue"),
  },
  {
    path: "/treasure",
    name: "treasure",
    component: () => import("@/views/setting/treasure/treasure.vue"),
  },
  {
    path: "/share",
    name: "share",
    component: () => import("@/views/setting/share/share.vue"),
  },
  {
    path: "/payInfo",
    name: "payInfo",
    component: () => import("@/views/pages/payInfo/payInfo.vue"),
  },
  {
    path: "/recharge",
    name: "recharge",
    component: () => import("@/views/setting/recharge/index.vue"),
  },
  {
    path: "/commissionRanking",
    name: "commissionRanking",
    component: () => import("@/views/pages/commissionRanking/commissionRanking.vue"),
  },
  {
    path: "/deposit-tutorial",
    name: "deposit-tutorial",
    component: () => import("@/views/tutorial/deposit.vue"),
  },
  {
    path: "/withdrawal-tutorial",
    name: "withdrawal-tutorial",
    component: () => import("@/views/tutorial/withdrawal.vue"),
  },
  {
    path: "/transfer-tutorial",
    name: "transfer-tutorial",
    component: () => import("@/views/tutorial/transfer.vue"),
  },
  {
    path: "/handicap-tutorial",
    name: "handicap-tutorial",
    component: () => import("@/views/tutorial/handicap.vue"),
  },
  {
    path: "/simulate-bet",
    name: "simulate-bet",
    component: () => import("@/views/tutorial/simulateBet.vue"),
  },
  {
    path: "/sports-rules",
    name: "sports-rules",
    component: () => import("@/views/tutorial/sportsRules.vue"),
  },
  {
    path: "/gameplay-tutorial",
    name: "gameplay-tutorial",
    component: () => import("@/views/tutorial/gameplayTutorial.vue"),
  },
  {
    path: "/single-bet",
    name: "single-bet",
    component: () => import("@/views/singleBet/singleBet.vue"),
  },
  {
    path: "/parlay",
    name: "parlay",
    component: () => import("@/views/parlay/parlay.vue"),
  },
  // 可以添加404页面捕获未匹配路由
  {
    path: "*",
    redirect: "/",
  },
];

// 创建路由实例
const router = new VueRouter({
  mode: "hash", // 可选hash模式
  base: process.env.BASE_URL,
  routes,
});

// ================== 捕获导航重复错误 ==================
// 保存原始 push 方法
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch((err) => err);
};

// 保存原始 replace 方法
const originalReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalReplace.call(this, location, onResolve, onReject);
  return originalReplace.call(this, location).catch((err) => err);
};
// =======================================================

function isAppModeRoute(route) {
  if (route?.query?.type === "app") return true;
  if (typeof window === "undefined") return false;

  const searchParams = new URLSearchParams(window.location.search);
  if (searchParams.get("type") === "app") return true;

  const hashQuery = (window.location.hash.split("?")[1] || "").split("#")[0];
  return new URLSearchParams(hashQuery).get("type") === "app";
}

router.beforeEach((to, from, next) => {
  const isAppMode = isAppModeRoute(to);
  const isInitialNavigation = !from || from.matched.length === 0;

  // App 模式首次打开或刷新时，先展示启动页，再进入目标页面。
  if (isAppMode && isInitialNavigation && to.path !== "/splash") {
    next({
      path: "/splash",
      query: { redirect: to.fullPath },
      replace: true,
    });
    return;
  }

  if (!isApiBaseReady()) {
    if (to.path === "/splash") {
      next();
      return;
    }
    next({
      path: "/splash",
      query: { redirect: to.path === "/splash" ? "/" : to.fullPath },
      replace: true,
    });
    return;
  }

  if (to.path === "/splash") {
    // 允许 App 模式启动页完成初始化。
    if (isAppMode && to.query.redirect) {
      next();
      return;
    }
    next({ path: "/", replace: true });
    return;
  }

  if (isLoggedIn()) {
    if (to.path === "/login" || to.path === "/register") {
      next({ path: "/", replace: true });
      return;
    }
    next();
    return;
  }

  if (isWhiteRoute(to.path)) {
    next();
    return;
  }

  next({
    path: "/login",
    query: { redirect: to.fullPath },
    replace: true,
  });
});

export default router;
